import * as React from "react";
import { IconProps } from "./types";

export default function Trending({ svgProps, pathProps }: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <g clipPath="url(#clip0_1052_698)">
        <path
          d="M6 14C6 14.87 6.18 15.69 6.53 16.46C6.88 17.23 7.38 17.91 8.03 18.5C8.01 18.42 8 18.34 8 18.27V18.04C8 17.51 8.1 17.01 8.3 16.54C8.5 16.07 8.79 15.65 9.18 15.26L12.01 12.48L14.84 15.26C15.22 15.64 15.52 16.07 15.72 16.54C15.92 17.01 16.02 17.51 16.02 18.04V18.27C16.02 18.34 16.02 18.41 15.99 18.5C16.64 17.92 17.14 17.24 17.49 16.46C17.84 15.68 18.02 14.86 18.02 14C18.02 13.14 17.87 12.38 17.56 11.64C17.25 10.9 16.81 10.24 16.22 9.64999C15.89 9.86999 15.54 10.03 15.17 10.14C14.8 10.25 14.43 10.3 14.04 10.3C13.01 10.3 12.11 9.95999 11.35 9.26999C10.59 8.57999 10.15 7.73999 10.04 6.73999C9.39 7.28999 8.81 7.85999 8.31 8.44999C7.81 9.03999 7.39 9.63999 7.05 10.25C6.71 10.86 6.45 11.48 6.27 12.11C6.09 12.74 6.01 13.37 6.01 13.99L6 14ZM12 15.3L10.57 16.7C10.39 16.88 10.24 17.09 10.14 17.33C10.04 17.57 9.99 17.81 9.99 18.06C9.99 18.59 10.19 19.05 10.58 19.44C10.97 19.83 11.44 20.02 11.99 20.02C12.54 20.02 13.01 19.83 13.4 19.44C13.79 19.05 13.99 18.6 13.99 18.06C13.99 17.79 13.94 17.55 13.84 17.32C13.74 17.09 13.6 16.89 13.41 16.71L11.98 15.31L12 15.3ZM12 2.99999V6.29999C12 6.86999 12.2 7.33999 12.59 7.72999C12.98 8.10999 13.46 8.30999 14.03 8.30999C14.33 8.30999 14.61 8.24999 14.87 8.11999C15.13 7.98999 15.36 7.80999 15.56 7.55999L16.01 7.00999C17.24 7.70999 18.22 8.68999 18.94 9.93999C19.66 11.19 20.02 12.55 20.02 14.02C20.02 16.25 19.24 18.15 17.69 19.7C16.14 21.25 14.25 22.03 12.01 22.03C9.77 22.03 7.88 21.25 6.33 19.7C4.78 18.15 4 16.23 4 14C4 11.77 4.72 9.80999 6.16 7.86999C7.6 5.93999 9.55 4.30999 12 2.98999V2.99999Z"
          fill="currentColor"
          {...pathProps}
        />
      </g>
      <defs>
        <clipPath id="clip0_1052_698">
          <rect
            width="16"
            height="19"
            fill="white"
            transform="translate(4 3)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
